// extracted by mini-css-extract-plugin
export default {"PatientsDoctor_Conclusion":"AppointmentConclusion_PatientsDoctor_Conclusion__uyGDm","PatientsDoctor_Conclusion_Icon":"AppointmentConclusion_PatientsDoctor_Conclusion_Icon__nG4uh"};